<script lang="ts" setup>
import { openGlobalUserProfile } from '@/components/helper'
import { app } from '@/composition/app'
import { replaceBucketUrlWithCdnUrl } from '@/helper/ImageUpload.helper'
import { GroupMemberRole } from '@/models/GroupMember'
import { IUser } from '@/models/Users'
import { UIPopover } from '@gohighlevel/ghl-ui'
import { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import UserProfilePopover from '../popover/UserProfilePopover.vue'
import BadgedAvatar from './BadgedAvatar.vue'

const { t } = useI18n()

defineProps({
  user: {
    type: Object as PropType<any>,
  },
  userRole: {
    type: String as PropType<GroupMemberRole>,
    default: undefined,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  showPopover: {
    type: Boolean,
    default: undefined,
  },
  avatarSize: {
    type: Number,
  },
})

const router = useRouter()
</script>
<template>
  <UIPopover
    placement="bottom-start"
    :show-arrow="false"
    raw
    :show="app.state.isMobile ? false : showPopover"
  >
    <template #trigger>
      <div
        tabindex="0"
        role="button"
        :aria-label="t('common.ariaLabels.userAvatar')"
        @click.stop.prevent="openGlobalUserProfile(user?.slug!, router)"
        @keyup.enter="openGlobalUserProfile(user?.slug!, router)"
      >
        <BadgedAvatar
          :avatar-url="replaceBucketUrlWithCdnUrl(user?.avatar)"
          :full-name="user?.fullName"
          :show-badge="showBadge"
          :role="userRole"
          :size="avatarSize"
          :level="user?.gamificationMeta?.level?.toString()"
        />
      </div>
    </template>
    <UserProfilePopover
      id="user_profile_tooltip"
      class="w-[460px]"
      :user="(user as IUser)"
      :user-role="userRole"
    />
  </UIPopover>
</template>
<style scoped></style>
